import { useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Use 'react-router-dom' instead of 'react-router'
import socket from "../../services/socket";

const LogOut = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("login_token")) {
      localStorage.removeItem("login_token");

      if (localStorage.getItem("login_user")) {
        localStorage.removeItem("login_user");
      }

      socket.disconnect();
      socket.off(); // Remove all event listeners properly
    }

    navigate("/login");
  }, [navigate]); // Add navigate as a dependency to avoid ESLint warnings

  return null; // Ensure the component returns something
};

export default LogOut;
